export function getApplicationStatusClass(status) {
  if (status === "Pending") {
    return "driver-application-badge driver-application-badge--pending";
  }
  if (status === "Approved") {
    return "driver-application-badge driver-application-badge--approved";
  }
  return "driver-application-badge driver-application-badge--rejected";
}
